import cover0 from "alphabet_images/0.png";
import cover1 from "alphabet_images/1.png";
import cover2 from "alphabet_images/2.png";
import cover3 from "alphabet_images/3.png";
import cover4 from "alphabet_images/4.png";
import cover5 from "alphabet_images/5.png";
import cover6 from "alphabet_images/6.png";
import cover7 from "alphabet_images/7.png";
import cover8 from "alphabet_images/8.png";
import cover9 from "alphabet_images/9.png";

import coverA from "alphabet_images/A.png";
import coverB from "alphabet_images/B.png";
import coverC from "alphabet_images/C.png";
import coverD from "alphabet_images/D.png";
import coverE from "alphabet_images/E.png";
import coverF from "alphabet_images/F.png";
import coverG from "alphabet_images/G.png";
import coverH from "alphabet_images/H.png";
import coverI from "alphabet_images/I.png";
import coverJ from "alphabet_images/J.png";
import coverK from "alphabet_images/K.png";
import coverL from "alphabet_images/L.png";
import coverM from "alphabet_images/M.png";
import coverN from "alphabet_images/N.png";
import coverO from "alphabet_images/O.png";
import coverP from "alphabet_images/P.png";
import coverQ from "alphabet_images/Q.png";
import coverR from "alphabet_images/R.png";
import coverS from "alphabet_images/S.png";
import coverT from "alphabet_images/T.png";
import coverU from "alphabet_images/U.png";
import coverV from "alphabet_images/V.png";
import coverW from "alphabet_images/W.png";
import coverX from "alphabet_images/X.png";
import coverY from "alphabet_images/Y.png";
import coverZ from "alphabet_images/Z.png";

const imageMapping = {
  0: cover0,
  1: cover1,
  2: cover2,
  3: cover3,
  4: cover4,
  5: cover5,
  6: cover6,
  7: cover7,
  8: cover8,
  9: cover9,
  A: coverA,
  B: coverB,
  C: coverC,
  D: coverD,
  E: coverE,
  F: coverF,
  G: coverG,
  H: coverH,
  I: coverI,
  J: coverJ,
  K: coverK,
  L: coverL,
  M: coverM,
  N: coverN,
  O: coverO,
  P: coverP,
  Q: coverQ,
  R: coverR,
  S: coverS,
  T: coverT,
  U: coverU,
  V: coverV,
  W: coverW,
  X: coverX,
  Y: coverY,
  Z: coverZ,
};

export default imageMapping;
